/* POST /v1/{practice}/auth/forgot-password, and what its answer means.

   The gateway makes every reset token itself (sec-release-1018): the `token`
   in the body is ignored, the server stores its own and mails
   <site>/reset/<token> to the address on file. It answers 201 whether or not
   the address is registered, so the caller cannot use it to find out who has
   an account - and there is nothing left for the caller to send.

   An older gateway stored the caller's token and answered 200, leaving the
   caller to mail the link. Both are a success; anything else is a failure.
   Treating only 200 as success is what made the Users screen's Resend, Add
   User's activation mail and the login page's Forgot password all report
   "Something went wrong" after the server had already sent the mail. */

// The gateway made the token and mailed the link; send nothing more.
export const RESET_SENT_BY_SERVER = 201;
// An older gateway stored the caller's token; the caller mails the link.
export const RESET_CALLER_MAILS = 200;

export const resetAccepted = (status) =>
  Number(status) === RESET_SENT_BY_SERVER || Number(status) === RESET_CALLER_MAILS;

// What to tell the user when the server handled it. The gateway's own wording
// is deliberately non-committal about whether the address exists; keep it.
export const resetSentMessage = (response, fallback) =>
  (response && typeof response.message === "string" && response.message.trim()) || fallback;
